import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import { TipoEmendaParlamentar } from '../TipoEmendaParlamentar';
import LinkToConvenio from './LinkToConvenio.react';

export default function FormDetailInformacoesAdicionais({
  informacaoAdicional,
  tipo,
  isIntegradoOxy
}) {
  if (!informacaoAdicional) {
    return <p className="text-muted">Nenhuma informação adicional.</p>;
  }

  const leiAto = informacaoAdicional.get('leiAto');
  const convenio = informacaoAdicional.get('convenio');
  const contrato = informacaoAdicional.get('contrato');
  const licitacao = informacaoAdicional.get('licitacao');
  const contaBancaria = informacaoAdicional.get('contaBancaria');

  const isEmendaMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;

  return (
    <DisplayData border>
      <DisplayDataRow>
        <DisplayDataItem
          sm={6}
          title="Convênio"
          value={
            <LinkToConvenio
              id={convenio?.get('id')}
              numero={convenio?.get('numero')}
              ano={convenio?.get('ano')}
              nomeBeneficiario={convenio?.getIn(['beneficiario', 'pessoa', 'nome'])}
              isIntegradoOxy={isIntegradoOxy}
            />
          }
          id="numeroAnoConvenio"
        />
        <DisplayDataItem
          sm={6}
          title="Contrato"
          value={`${contrato?.get('numeroContrato') ?? ''}/${
            contrato?.get('anoContrato') ?? ''
          } ${contrato?.getIn(['fornecedor', 'nome']) ?? ''}`}
          id="numeroAnoContrato"
        />
        <DisplayDataItem
          sm={6}
          title="Lei/Ato"
          value={`${leiAto?.get('numero') ?? ''}/${
            leiAto?.get('exercicio') ?? ''
          } ${leiAto?.getIn(['escopo', 'descricao']) ?? ''}`}
          id="numeroAnoLeiAto"
        />
        <DisplayDataItem
          sm={6}
          title="Processo Administrativo"
          value={informacaoAdicional.get('numeroProcesso')}
          id="numeroProcesso"
        />
      </DisplayDataRow>
      <DisplayDataRow>
        <DisplayDataItem
          sm={6}
          title="Modalidade Licitação"
          value={informacaoAdicional.get('tipoLicitacao')}
          id="tipoLicitacao"
        />
        <DisplayDataItem
          sm={6}
          title="Licitação"
          value={`${licitacao?.get('numeroLicitacao') ?? ''}/${
            licitacao?.get('ano') ?? ''
          }`}
          id="numeroAnoLicitacao"
        />
      </DisplayDataRow>
      {(isIntegradoOxy || (!isIntegradoOxy && !isEmendaMunicipal)) && (
        <>
          <DisplayDataRow>
            <DisplayDataItem
              sm={6}
              title="Tipo Fase Transferência"
              value={informacaoAdicional.get('tipoFaseTransferencia')}
              id="tipoFaseTransferencia"
            />
            <DisplayDataItem
              sm={6}
              title="Conta Bancária"
              value={`${contaBancaria?.get('conta') ?? ''} ${
                contaBancaria?.get('descricao') ?? ''
              }`}
              id="contaBancaria"
            />
          </DisplayDataRow>
        </>
      )}
    </DisplayData>
  );
}

FormDetailInformacoesAdicionais.propTypes = {
  informacaoAdicional: PropTypes.object,
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  isIntegradoOxy: PropTypes.bool
};
